import { useAsyncValue, useRequestConnectedToAsyncValue } from '../../../../../hooks';
import { put } from '../../../../../redux/api';
import type { ProjectGroup } from '../../../../../../shared/model-typings';
import type { UpdateProjectGroupRequest } from '../../../../../../typings/api';

//  Function to update the release group
const updateReleaseGroup = (groupId: number, requestBody: UpdateProjectGroupRequest) =>
  put<UpdateProjectGroupRequest, ProjectGroup>(`/api/project_group/${groupId}`, requestBody);

/**
 * useUpdateReleaseGroup is a hook which provides the async callback
 * that allows us to update the settings for a release group.
 */
const useUpdateReleaseGroup = () => {
  const value = useAsyncValue<ProjectGroup | null>(null);
  return useRequestConnectedToAsyncValue(updateReleaseGroup, value);
};

export default useUpdateReleaseGroup;
